import React from 'react';
import {Backdrop, CircularProgress} from '@mui/material';

interface LoaderOverlayProps {
    open: boolean;
}

const IssueReportLoaderOverlay = (props: LoaderOverlayProps) => {
    return (
        <Backdrop open={props.open} style={{ zIndex: 2 }}>
            <CircularProgress color={'secondary'} />
        </Backdrop>
    );
};

export default IssueReportLoaderOverlay;
